"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var react_1 = __importDefault(require("react"));
var lite_1 = __importDefault(require("algoliasearch/lite"));
var IndexHit_1 = __importDefault(require("./IndexHit"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var searchClient = lite_1.default(window.Algolia.app_id, window.Algolia.search_key);
var Menu = react_instantsearch_dom_1.connectMenu(function (_a) {
    var items = _a.items, refine = _a.refine;
    var provinces = [
        'Antwerpen',
        'Henegouwen',
        'Limburg',
        'Luik',
        'Luxemburg',
        'Namen',
        'Oost-Vlaanderen',
        'Vlaams-Brabant',
        'Waals-Brabant',
        'West-Vlaanderen',
    ];
    var missingProvinces = provinces
        .filter(function (province) { return items.filter(function (item) { return item.label === province; }).length === 0; })
        .map(function (province) {
        return {
            count: 0,
            label: province,
            isRefined: false,
            value: province,
        };
    });
    items.push.apply(items, missingProvinces);
    return (react_1.default.createElement("nav", { className: "mt-8" },
        react_1.default.createElement("ul", { className: "grid grid-cols-3 md:grid-cols-5 xl:grid-cols-10 gap-1 items-center justify-between font-medium text-xs" }, sortBy_1.default(items, function (item) { return item.label.toUpperCase(); }).map(function (item) { return (react_1.default.createElement("li", { key: item.value },
            react_1.default.createElement("a", { href: "#", className: "truncate block xl:text-center px-3 py-1 " + (item.isRefined ? 'bg-teal-500 text-white' : 'bg-gray-300 text-gray-500'), onClick: function (event) {
                    event.preventDefault();
                    refine(item.value);
                } }, window.__(item.label)))); }))));
});
var Hits = react_instantsearch_dom_1.connectHits(function (_a) {
    var hits = _a.hits;
    return (react_1.default.createElement("div", { className: "mt-6 grid grid-cols-auto-1fr gap-x-16" },
        hits.length > 0 && hits.map(function (hit) { return (react_1.default.createElement(IndexHit_1.default, { key: hit.objectID, hit: hit })); }),
        hits.length === 0 && (react_1.default.createElement("div", { className: "col-span-2 py-3 text-sm text-center text-gray-500" }, window.__('Geen resultaten')))));
});
function Provinces() {
    return (react_1.default.createElement(react_instantsearch_dom_1.InstantSearch, { searchClient: searchClient, indexName: window.Algolia.index_name },
        react_1.default.createElement(react_instantsearch_dom_1.Configure, { filters: "locale:" + window.locale, hitsPerPage: 50, sortFacetValuesBy: 'alpha' }),
        react_1.default.createElement("div", { className: "flex" },
            react_1.default.createElement("section", { className: "w-full" },
                react_1.default.createElement(Menu, { attribute: "state", defaultRefinement: "Antwerpen" }),
                react_1.default.createElement(Hits, null)))));
}
exports.default = Provinces;
